import React from 'react';

import ShieldIcon from '@atlaskit/icon/core/shield';

export const DataProtectionIconV2 = () => <ShieldIcon label="" spacing="spacious" />;
